import { useState } from 'react';

import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';

import { useRevisionIncrement } from '@/hooks/useRevisionIncrement';
import { formatURLDate } from '@/utils/formatting';

interface TopRevisionsButtonProps {
  disabled?: boolean;
  date?: string;
  label?: string;
  icon?: string;
  size?: string;
  className?: string;
  tooltip?: string;
  type?: 'button' | 'submit' | 'reset';
  hideTrigger?: boolean;
  visible?: boolean;
  onHide?: () => void;
}

export const TopRevisionsButton = ({
  label,
  icon,
  size,
  type,
  className,
  tooltip,
  disabled = false,
  date,
  hideTrigger = false,
  visible,
  onHide,
}: TopRevisionsButtonProps) => {
  const [internalVisible, setInternalVisible] = useState(false);

  const { allTopRevisionNumbers } = useRevisionIncrement(date);

  const dialogVisible = visible !== undefined ? visible : internalVisible;
  const handleHide = onHide || (() => setInternalVisible(false));

  return (
    <>
      {!hideTrigger && (
        <div className="label-input-group">
          <label> </label>
          <Button
            label={label}
            icon={icon}
            size={size as 'small' | 'large'}
            className={className}
            tooltip={tooltip}
            tooltipOptions={{ position: 'left' }}
            type={type}
            onClick={() => {
              if (visible === undefined) {
                setInternalVisible(true);
              }
            }}
            disabled={disabled}
          />
        </div>
      )}
      <Dialog
        visible={dialogVisible}
        onHide={handleHide}
        header={`All Top Revision Numbers Per Fertilization Site ${formatURLDate(date ?? '')}`}
        className="w-[80vw]"
      >
        <DataTable
          value={allTopRevisionNumbers ?? []}
          scrollable
          scrollHeight="400px"
          className="w-full"
        >
          <Column field="revisionNumber" header="Revision Number" />
          <Column
            field="fertilizationSiteName"
            header="Fertilization Site Name"
          />
        </DataTable>
      </Dialog>
    </>
  );
};
